import { ClientInferResponseBody } from "@ts-rest/core";
import z from "zod";

import {
  patientsApiContract,
  redeterminationStatusEnumSchema,
} from "@libs/api/patients";
import { HTTPStatusCode } from "@libs/api/types";

export type RedeterminationType = ClientInferResponseBody<
  typeof patientsApiContract.redeterminations.getRedetermination,
  typeof HTTPStatusCode.OK
>;

export const updateRedeterminationSchema =
  patientsApiContract.redeterminations.updateRedetermination.body;
export type UpdateRedeterminationType = z.infer<
  typeof updateRedeterminationSchema
>;

const listRedeterminationsQuerySchema =
  patientsApiContract.redeterminations.listRedeterminations.query;

export const listRedeterminationsFilterSchema = listRedeterminationsQuerySchema;

export type ListRedeterminationsFilterType = z.infer<
  typeof listRedeterminationsFilterSchema
>;

export type RedeterminationStatusType = z.infer<
  typeof redeterminationStatusEnumSchema
>;

export type RedeterminationStepType =
  | "CHOOSING_STATUS"
  | "CONFIRM_ADDRESS"
  | "CASE_NUMBER"
  | "SUCCESS";

export const caseNumberFormSchema = z.object({
  caseNumber: z.string().optional(),
});
export type CaseNumberFormType = z.infer<typeof caseNumberFormSchema>;
